import { useEffect, useMemo, useSyncExternalStore } from 'react';
import type { GitHub } from '../github/client';
import { Workspace, type WorkspaceDeps } from './workspace';

const RESCAN_MS = 10_000;

export function useWorkspace(gh: GitHub, repo: WorkspaceDeps['repo'], overrides: Partial<WorkspaceDeps> = {}) {
  const ws = useMemo(() => new Workspace({ gh, repo, ...overrides }), [gh, repo.full]); // eslint-disable-line react-hooks/exhaustive-deps
  const phase = useSyncExternalStore(ws.subscribe, () => ws.phase);

  useEffect(() => {
    void ws.start();
    // Change detection (SPEC §4): no file-watch API, so re-scan on focus and on an interval while visible.
    const onFocus = () => void ws.refresh();
    const timer = setInterval(() => { if (document.visibilityState === 'visible') void ws.refresh(); }, RESCAN_MS);
    addEventListener('focus', onFocus);
    return () => { clearInterval(timer); removeEventListener('focus', onFocus); ws.dispose(); };
  }, [ws]);

  return { ws, phase };
}
